import {
  discordInviteUrl,
  getToolById,
  supportDevelopmentUrl,
  youtubeChannelUrl,
} from './toolCatalog';

export const featuredLinksVideo = {
  id: '3a8-PfYVLgo',
  title: 'Latest YouTube Video',
  description: 'Watch my newest tutorial, workflow, or creator tip.',
  url: 'https://www.youtube.com/watch?v=3a8-PfYVLgo',
  thumbnail: 'https://img.youtube.com/vi/3a8-PfYVLgo/maxresdefault.jpg',
};

const clipboardIt = getToolById('clipboardit');
const youTool = getToolById('youtool-io');

export const flagshipCreatorLinks = [
  {
    id: 'clipboardit',
    title: 'Clipboard It',
    description: '',
    url: clipboardIt?.destinationUrl || 'https://clipboard.it.com/',
    image: clipboardIt?.image,
  },
  {
    id: 'youtool-io',
    title: youTool?.title || 'YouTool.io',
    description: '',
    url: youTool?.destinationUrl || 'https://www.youtool.io',
    image: youTool?.image,
  },
];

export const creatorHubLinks = [
  {
    id: 'store',
    title: 'Browse All Tools',
    description: 'Chrome extensions, Premiere Pro plugins, templates, and more.',
    url: '/store',
    icon: 'bx-grid-alt',
    external: false,
  },
  {
    id: 'creator-updates',
    title: 'Free Client Project Folder',
    description: 'Get the project folder I use for client work, plus a guide on how to use it.',
    url: '#creator-updates',
    icon: 'bx-envelope',
    external: false,
  },
  {
    id: 'support-development',
    title: 'Support Development',
    description: 'Support future tools.',
    url: supportDevelopmentUrl,
    icon: 'bx-coffee',
    external: true,
  },
];

export const secondaryCreatorLinks = [
  {
    id: 'youtube',
    title: 'YouTube',
    url: youtubeChannelUrl,
    icon: 'bxl-youtube',
    external: true,
  },
  {
    id: 'discord',
    title: 'Discord',
    url: discordInviteUrl,
    icon: 'bxl-discord-alt',
    external: true,
  },
  {
    id: 'contact',
    title: 'Contact',
    url: '/contact',
    icon: 'bx-envelope',
    external: false,
  },
];
